import { ModuleSummaryPage, MODULE_SUMMARY_CASES, type ModuleSummaryCaseKey } from '@quebon/shared-learning'

const A4_WIDTH = 794
const A4_HEIGHT = 1123

const CASE_LABELS: Record<ModuleSummaryCaseKey, string> = {
  caseYellow: 'Case Yellow — colorIndex 0 (figma 520:700/713)',
  caseGreen: 'Case Green — colorIndex 1 (figma 520:881/894)',
  caseRed: 'Case Red — colorIndex 2 (figma 520:1015/520:1028)',
}

export default function ModuleSummaryPreviewDev() {
  const keys = Object.keys(MODULE_SUMMARY_CASES) as ModuleSummaryCaseKey[]
  return (
    <div style={{ background: '#f5f5f5', padding: 32, minHeight: '100vh' }}>
      <h1 style={{ marginBottom: 24, fontFamily: 'sans-serif' }}>Module Summary Preview — 3 Color Cases</h1>
      {keys.map((key) => {
        const c = MODULE_SUMMARY_CASES[key]
        return (
          <section key={key} style={{ marginBottom: 48 }}>
            <h2 style={{ fontFamily: 'sans-serif', fontSize: 18, marginBottom: 8 }}>{CASE_LABELS[key]}</h2>
            <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
              <ModuleSummaryPage
                moduleIndex={c.chapterNumber - 1}
                moduleName={c.moduleName}
                colorIndex={c.colorIndex}
                lessons={c.lessons}
                pageWidth={A4_WIDTH}
                pageHeight={A4_HEIGHT}
              />
            </div>
          </section>
        )
      })}
    </div>
  )
}
